module.exports = __webpack_public_path__ + "media/src/public/img/payment/euro-1df17d4eb0d008758aed84d41b4daa95.svg";